import ls from 'localstorage-slim';
import { LocalStorageKeyCollection } from '../../Constants/KeyCollection/LocalStorageKeyCollection';

export class ConfigHelper {
    static async getBoolConfigValueAsync(configId: ConfigDefinition): Promise<boolean> {
        const tmp = await this.getConfigValueAsync<boolean>(configId, true);
        return tmp;
    }

    static getBoolConfigValue(configId: ConfigDefinition, callback: (value: any | null) => void) {
        this.getConfigValue(configId, (result) => {
            callback(result);
        });
    }

    // getStringConfigValue
    static async getStringConfigValueAsync(configId: ConfigDefinition): Promise<string> {
        return await this.getConfigValueAsync<string>(configId);
    }

    // getNumberConfigValue
    static async getNumberConfigValueAsync(configId: ConfigDefinition): Promise<number> {
        return await this.getConfigValueAsync<number>(configId);
    }

    // getConfigValue
    static getConfigValue(configId: number, callback: (value: any | null) => void) {
        try {
            ConfigHelper.request(configId, (resp) => {
                if (resp.Value == null) {
                    callback(null);
                }

                callback(resp.Value);
            });
        } catch (e) {
            console.error(e);
            callback(null);
        }
    }

    // getConfigValue
    static async getConfigValueAsync<T>(configId: ConfigDefinition, isBool?: boolean): Promise<T> {
        let resultPromise = new Promise<T>((resolve, reject) => {
            ConfigHelper.request(configId, (resp) => {
                if (resp == null) {
                    reject();
                }
                resolve(isBool && resp.Value == null ? false : resp.Value);
            });
        });

        return resultPromise;
    }

    private static async request(configId: ConfigDefinition, callback: (resp: any | null) => void) {
        const res = ls.get<IConfigRes[]>(LocalStorageKeyCollection.configCache);
        if (res != null) {
            callback(this.getValue(configId, res));
            return;
        }

        AxessViewer.ajaxRequest('/api/ConfigurationApi/GetConfig', {}, (resp: IConfigRes[]) => {
            ls.set(LocalStorageKeyCollection.configCache, resp, { ttl: 60 * 5 });
            callback(this.getValue(configId, resp));
        }, {
            type: 'POST'
        });
    }

    private static getValue(config: ConfigDefinition, res: IConfigRes[]) {
        return res?.find(x => x.ConfigId == config);
    }
}

export interface IConfigRes {
    ConfigId: number;
    Value: string | number | boolean;
}

export enum ConfigDefinition {
    SubContingentLockAllEarlier = 188,
    RentalDataTextInput = 202,
    StoreCurrencyWebUseIsoSymbol = 7,
    RentalIsAllowedActivated = 468
}